import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/ai-agents']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];

const createAiAgent = async ({ questionnaireTemplateId, creatorId, aiModel, instructions, fieldData, externalData, internalData, title, fieldOutputs }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/ai-agents', {creatorId, questionnaireTemplateId });
  const data = await formsBackendClient.post(path, { aiModel, externalData, fieldData, fieldOutputs, instructions, internalData, title });
  return data.data;
};

export default createAiAgent;